/**
 * 作品ごとに学習した「次の動画」プレビューの基準秒数を取得し、新しい学習データを送るフック
 * 通信に失敗しても再生には影響させない（未学習として既定の秒数で動く）
 */
import { useCallback, useEffect, useState } from 'react'

import { addNextTimingSample, getNextTiming } from '@/api/api'

export const useNextEpisodeTiming = (productId: number | undefined) => {
  const [learnedRemainingSec, setLearnedRemainingSec] = useState<number | null>(null)

  useEffect(() => {
    if (!productId || !navigator.onLine) return
    let cancelled = false
    getNextTiming(productId)
      .then((timing) => {
        if (!cancelled) setLearnedRemainingSec(timing.remaining_seconds)
      })
      .catch(() => undefined)
    return () => {
      cancelled = true
    }
  }, [productId])

  const recordSample = useCallback(
    (remainingSec: number) => {
      if (!productId || !navigator.onLine) return
      addNextTimingSample(productId, remainingSec).catch(() => undefined)
    },
    [productId],
  )

  return { learnedRemainingSec, recordSample }
}
